import React from "react";
import Link from "next/link";
import styles from "@buddieshr/styles/billy/compareLinks.module.scss";

const CompareLinks = () => (
  <div className={styles.CompareLinks_wrapper}>
    <div className={styles.CompareLinks_inner}>
      <h2 className={styles.CompareLinks_title}>Billy compares to leaders</h2>
      <div className={styles.CompareLinks_links}>
        <Link
          href="/billy/alternatives/birthdaybot"
          className={styles.CompareLinks_link}
        >
          Birthday Bot
        </Link>
        <Link
          href="/billy/alternatives/donut"
          className={styles.CompareLinks_link}
        >
          Donut
        </Link>
        <Link
          href="/billy/alternatives/airspeed"
          className={styles.CompareLinks_link}
        >
          Airspeed
        </Link>
      </div>
    </div>
  </div>
);

export default CompareLinks;
